// eslint-disable-next-line
export const PRODUCTS_ADD = 'PRODUCTS_SAVE';
